// extracted by mini-css-extract-plugin
module.exports = {"shadow":"table_shadow__2mc9N","textShadow":"table_textShadow__1K2KR","container":"table_container__2l3Yw"};